import { useEffect, useRef } from 'react';

import { globalConst, loadYandexMap } from 'modules/global';

interface IProps {
  latitude?: number;
  longitude?: number;
  logoUrl?: string;
  zoom?: number;
  height?: string;
}

const YandexMap: React.FC<IProps> = ({ latitude, longitude, logoUrl, zoom = 15, height = '300px' }) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<any>(null);

  useEffect(() => {
    loadYandexMap().then(() => {
      const { ymaps } = window as any;

      ymaps.ready(() => {
        if (mapInstanceRef.current) return;

        const mapCenter = [
          latitude ?? globalConst.defaultLocation.latitude,
          longitude ?? globalConst.defaultLocation.longitude
        ];

        const map = new ymaps.Map(mapRef.current!, {
          center: mapCenter,
          zoom
        });

        mapInstanceRef.current = map;

        const customLayout = ymaps.templateLayoutFactory.createClass(`
            <div style="position: relative; width: 30px; height: 40px;">
              <img alt="Yandex map mark" src="/images/pin.png" style="width: 30px; height: 40px;" />
              <div style="position: absolute; top: 3px; left: 3px; width: 23px; height: 23px; background-color: #fff; border-radius: 50%; padding: 1px">
                <img alt="University logo mark" src="${logoUrl || '/images/default-no-logo.webp'}" style="border-radius: 50%;" />
              </div>
            </div>
          `);

        const customMarker = new ymaps.Placemark(
          mapCenter,
          {},
          {
            iconLayout: customLayout,
            iconAnchor: [15, 20],
            iconShape: {
              type: 'Circle',
              coordinates: [0, 0],
              radius: 30
            }
          }
        );

        map.geoObjects.add(customMarker);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latitude, longitude, logoUrl]);

  return <div ref={mapRef} style={{ height }} className="!w-full overflow-hidden rounded-lg" />;
};

export default YandexMap;
